<ng-container
  *ngIf="singlePackagingResource$ | async as singlePackagingResource"
>
  <ng-container *ngIf="validationResource$ | async as validationResource">
    <div [formGroup]="form" *ngIf="form">
      <div id="ch-ggs-web-suite-packing-details">
        <h4 class="d-flex align-items-baseline">
          {{ singlePackagingResource['TitleContent'] }}
        </h4>
        <hr />
        <div class="form-group row">
          <label for="properShippingName" class="col-sm-3 col-form-label">{{
            singlePackagingResource['DangerousGood']
          }}</label>
          <div class="col-sm-9">
            <input
              id="properShippingName"
              type="text"
              class="form-control"
              formControlName="properShippingName"
              readonly
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">&nbsp;</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input
                id="useAlternativeProperShippingName"
                type="checkbox"
                class="form-check-input"
                [checked]="model?.UseAlternativeProperShippingName"
                (change)="changeUseAlternativeProperShippingName($event)"
                formControlName="useAlternativeProperShippingName"
              />
              <label
                class="form-check-label"
                for="useAlternativeProperShippingName"
                >{{
                  singlePackagingResource['UseAlternativeProperShippingName']
                }}</label
              >
            </div>
          </div>
        </div>

        <div
          class="form-group row"
          [class.hidden]="!useAlternativeProperShippingName?.value"
        >
          <label class="col-sm-3">{{
            singlePackagingResource['AlternativeProperShippingName']
          }}</label>
          <div class="col-sm-9">
            <input
              id="alternativeProperShippingName"
              type="text"
              class="form-control"
              formControlName="alternativeProperShippingName"
            />
            <span
              *ngIf="
                alternativeProperShippingName?.invalid &&
                (alternativeProperShippingName?.dirty ||
                  alternativeProperShippingName?.touched)
              "
              class="text-danger"
            >
              {{ validationResource['InputRequired'] }}
            </span>
          </div>
        </div>

        <div class="form-group row" *ngIf="model?.IsTechnicalNameRequired">
          <label for="technicalName" class="col-sm-3 col-form-label h4">{{
            singlePackagingResource['TechnicalName']
          }}</label>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control"
              id="technicalName"
              formControlName="technicalName"
            />
            <span
              *ngIf="
                technicalName?.invalid &&
                (technicalName?.dirty || technicalName?.touched)
              "
              class="text-danger"
            >
              {{ validationResource['InputRequired'] }}
            </span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">{{
            singlePackagingResource['EnvironmentallyHazardous']
          }}</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input
                id="isEnvironmentallyHazardous"
                type="checkbox"
                class="form-check-input"
                [checked]="
                  model?.IsEnvironmentallyHazardous ||
                  model?.IsEnvironmentallyHazardousFromDb
                "
                (change)="changeIsEnvironmentallyHazardous($event)"
                formControlName="isEnvironmentallyHazardous"
              />
              <label
                class="form-check-label"
                for="isEnvironmentallyHazardous"
                >{{
                  singlePackagingResource['EnvironmentallyHazardousItem']
                }}</label
              >
            </div>
          </div>
        </div>

        <div class="form-group row" *ngIf="model?.IsFlashpointRequired">
          <label
            for="frm-ch-ggs-web-suite-reference"
            class="col-sm-3 col-form-label h4"
          >
            {{ singlePackagingResource['FlashPoint'] }}
          </label>
          <div class="col-sm-2">
            <input
              type="text"
              class="form-control"
              id="lowerFlashpoint"
              formControlName="lowerFlashpoint"
            />
          </div>
          <div class="col-sm-1">
            <label class="col-form-label">°C</label>
          </div>
          <span
            *ngIf="
              lowerFlashpoint?.invalid &&
              (lowerFlashpoint?.dirty || lowerFlashpoint?.touched)
            "
            class="text-danger"
          >
            {{ validationResource['InputRequired'] }}
          </span>
        </div>

        <h4>{{ singlePackagingResource['TitleClosure'] }}</h4>
        <hr />

        <div class="form-group row">
          <label class="col-sm-3 col-form-label" for="countOfPackagings">{{
            singlePackagingResource['ClosureCountAndType']
          }}</label>
          <div class="col-sm-9">
            <div class="row form-row">
              <div class="col-sm-3">
                <div>
                  <input
                    class="form-control"
                    type="number"
                    step="1"
                    id="countOfPackagings"
                    formControlName="countOfPackagings"
                  />
                </div>
                <span
                  *ngIf="
                    countOfPackagings?.invalid &&
                    (countOfPackagings?.dirty || countOfPackagings?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['PositiveInteger'] }}
                </span>
              </div>
              <div class="col-sm-6" *ngIf="!useAlternativePackagingType?.value">
                <select
                  id="packagingType"
                  formControlName="packagingType"
                  class="form-control"
                  (change)="changePackagingType($event)"
                >
                  <option *ngFor="let c of packageTypes" [value]="c.Id">
                    {{ c.Text }}
                  </option>
                </select>
                <span
                  *ngIf="
                    packagingType?.invalid &&
                    (packagingType?.dirty || packagingType?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['InputRequired'] }}
                </span>
              </div>
              <div class="col-sm-3" *ngIf="!useAlternativePackagingType?.value">
                <select
                  formControlName="packagingUnCode"
                  class="form-control"
                  (change)="changePackagingUnCode($event)"
                >
                  <option *ngIf="packagingUnCodes.length"></option>
                  <option *ngFor="let c of packagingUnCodes" [value]="c.Text">
                    {{ c.Text }}
                  </option>
                </select>
                <span
                  *ngIf="
                    packagingUnCode?.invalid &&
                    (packagingUnCode?.dirty || packagingUnCode?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['InputRequired'] }}
                </span>
              </div>
              <div class="col-sm-9" *ngIf="useAlternativePackagingType?.value">
                <div>
                  <input
                    class="form-control"
                    type="text"
                    id="alternativePackagingType"
                    formControlName="alternativePackagingType"
                  />
                </div>
                <span
                  *ngIf="
                    alternativePackagingType?.invalid &&
                    (alternativePackagingType?.dirty ||
                      alternativePackagingType?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['InputRequired'] }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">&nbsp;</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input
                id="useAlternativePackagingType"
                type="checkbox"
                class="form-check-input"
                [checked]="model?.UseAlternativePackagingType"
                (change)="changeUseAlternativePackagingType($event)"
                formControlName="useAlternativePackagingType"
              />
              <label
                class="form-check-label"
                for="frm-ch-ggs-web-suite-check"
                >{{
                  singlePackagingResource['UseAlternativePackagingType']
                }}</label
              >
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">{{
            singlePackagingResource['AmountType']
          }}</label>
          <div class="col-sm-9">
            <div class="radio">
              <input
                id="singlePackaging"
                type="radio"
                formControlName="isTotalQuantity"
                [value]="false"
              />
              <label for="singlePackaging" class="ml-2">{{
                singlePackagingResource['IsSingleQuantity']
              }}</label>
            </div>
            <div class="radio">
              <input
                id="totalPackaging"
                type="radio"
                formControlName="isTotalQuantity"
                [value]="true"
              />
              <label for="totalPackaging" class="ml-2">{{
                singlePackagingResource['IsTotalQuantity']
              }}</label>
            </div>
          </div>
        </div>

        <div class="form-group row" *ngIf="model?.IsLithiumBattery">
          <label class="col-sm-3">
            {{ singlePackagingResource['LithiumBatteriesSectionIB'] }}
          </label>
          <div class="col-sm-9">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lithiumBatteryShipmentModeIB"
                formControlName="lithiumBatteryShipmentModeIB"
                [checked]="model?.LithiumBatteryShipmentModeIB"
              />
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label
            class="col-sm-3 col-form-label"
            for="netWeight"
            [class.h4]="model?.IsNetWeightMandatory"
            >{{ singlePackagingResource['NetAmount'] }}</label
          >
          <div class="col-sm-9">
            <div class="row form-row">
              <div class="col-sm-3">
                <div>
                  <input
                    [class.form-control-mandatory]="model?.IsNetWeightMandatory"
                    class="form-control"
                    type="text"
                    id="netWeight"
                    formControlName="netWeight"
                  />
                </div>
                <span
                  *ngIf="
                    netWeight?.invalid &&
                    (netWeight?.dirty || netWeight?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['PositiveInteger'] }}
                </span>
              </div>
              <div class="col-sm-3">
                <label class="col-form-label">
                  {{ model?.NetWeightUnitSymbol }}
                </label>
              </div>
              <ng-container *ngIf="model?.IsNetVolumeEnabled">
                <div class="col-sm-3">
                  <div>
                    <input
                      [class.form-control-mandatory]="
                        model?.IsNetVolumeMandatory
                      "
                      class="form-control"
                      type="text"
                      id="netVolume"
                      formControlName="netVolume"
                    />
                  </div>
                  <span
                    *ngIf="
                      netVolume?.invalid &&
                      (netVolume?.dirty || netVolume?.touched)
                    "
                    class="text-danger"
                  >
                    {{ validationResource['PositiveInteger'] }}
                  </span>
                </div>
                <div class="col-sm-3">
                  <div>
                    <label class="col-form-label">
                      {{ model?.NetVolumeUnitSymbol }}
                    </label>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="model?.IsNetExplosiveMassMandatory">
          <label class="col-sm-3 col-form-label h4">{{
            singlePackagingResource['NetExplosiveMass']
          }}</label>
          <div class="col-sm-9">
            <div class="row form-row">
              <div class="col-sm-3">
                <div>
                  <input
                    class="form-control form-control-mandatory"
                    type="text"
                    id="netExplosiveMass"
                    formControlName="netExplosiveMass"
                  />
                </div>
                <span
                  *ngIf="
                    netExplosiveMass?.invalid &&
                    (netExplosiveMass?.dirty || netExplosiveMass?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['PositiveInteger'] }}
                </span>
              </div>
              <div class="col-sm-3">
                <label class="col-form-label">{{
                  model?.NetExplosiveMassUnitSymbol
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label
            class="col-sm-3 col-form-label"
            [class.h4]="model?.IsGrossWeightMandatory"
          >
            {{ singlePackagingResource['GrossWeight'] }}
          </label>
          <div class="col-sm-9">
            <div class="row form-row">
              <div class="col-sm-3">
                <div>
                  <input
                    class="form-control"
                    type="text"
                    id="grossWeight"
                    formControlName="grossWeight"
                  />
                </div>
                <span
                  *ngIf="
                    grossWeight?.invalid &&
                    (grossWeight?.dirty || grossWeight?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['PositiveInteger'] }}
                </span>
              </div>
              <div class="col-sm-3">
                <label class="col-form-label">{{
                  model?.GrossWeightUnitSymbol
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
